import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { IConnectedPage } from '../../../types/api/connectedPages/IConnectedPage';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { ConnectedPagesTree } from '../../../_lib/components/ConnectedPages';
import { useAppContext } from '../../../contexts/AppContext/AppContext';
import { isNonEmptyArray } from '../../../lib/typeGuards';

type ChildPagesDefaultViewProps = { title?: string; connectedPages: IConnectedPage[]; initialVisibleDepth?: number };

export function ChildPagesDefault({ title, connectedPages, initialVisibleDepth = 1 }: ChildPagesDefaultViewProps) {
  const { t } = useSonTranslation('ChildPagesBlock');
  const { uuid } = useBlockContext();
  const { editModeInfo } = useAppContext();

  const hasConnectedPages = isNonEmptyArray(connectedPages);

  if (editModeInfo.active) {
    return (
      <div className="child-pages__content-info">
        <span>{hasConnectedPages ? t('childPagesAvailable') : t('noChildPages')}</span>
      </div>
    );
  }

  return hasConnectedPages
    ? (
        <>
          <h2 className="child-pages__headline" id={`child-pages-block-headline-${uuid}`}>
            {title || t('childPages')}
          </h2>
          <ConnectedPagesTree connectedPages={connectedPages} initialVisibleDepth={initialVisibleDepth} />
        </>
      )
    : null;
}

export const ChildPagesDefaultView = asView(ChildPagesDefault);
export type ChildPagesDefaultView = ComponentProps<typeof ChildPagesDefaultView>;
